<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="Form"
          :model="ProgramData"
          :rules="rules"
          label-width="120px"
          style="width: 90%"
        >
          <div class="program-transfer">
            <el-form-item>
              <el-transfer
                style="text-align: left; display: inline-block"
                filterable
                filter-placeholder="节目名称"
                :props="{ key: 'id', label: 'showName' }"
                :titles="['备选节目', '确认节目']"
                :data="notChoiceDataList"
                v-model="ProgramData.choiceDataList"
                @change="handleChange"
              >
                <!-- <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span> -->
              </el-transfer>
            </el-form-item>
          </div>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button @click="preStep">上一步</el-button>
        <el-button type="primary" @click="OnConfirm('Form')"
          >保存,下一步</el-button
        >
        <!-- <el-button @click="nextStep">下一步</el-button> -->
        <el-button @click="onBack">返回</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import { BroadcastShowList,addBroadcastOrderShow,editBroadcastOrderShow,BroadcastOrderShowList,batchUpdate } from "@/api/src/broadcast";
export default {
  name: "ProgramManagerInfo",
  props: {
    ProgramList: {
      type: Array,
    },
    taskId: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      rules: {},
      ProgramData: { choiceDataList: [] },
      notChoiceDataList: [], //备选节目
    };
  },
  created() {
    this.getProgram();
    this.getOrderProgramshowList();
  },
  methods: {
    getProgram() {
      // const searchInfo = {
      //   PageSize: 100,
      //   PageIndex: 1,
      //   IsPublished: 1,
      //   TotalCount: 0,
      //   StartNumber: 0,
      //   EndNumber: 0,
      // };
      const that = this;
      // new MyApis.ProgramApi()
      //   .GetPageContentByConditions(searchInfo)
      //   .then((r) => {
      //     r = r.data.Data;
      //     that.ProgramListAll = r.PageContents;
      //     that.notChoiceDataList = r.PageContents;
      //     that.ProgramData.choiceDataList = that.ProgramList.map((item) => {
      //       return item.ProgramId;
      //     });
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //   });
      const searchInfo = {
        // showName: this.showName,
        publishStatus: 1,
        PageSize: 999,
        pageNum: 1,
      };
      BroadcastShowList(searchInfo).then(res=>{
        this.loading = false;
        if(res.code==200){
          this.ProgramListAll = res.rows;
          this.notChoiceDataList = res.rows;
          console.log( "this.notChoiceDataList")
          console.log( this.notChoiceDataList)
        }else{
          this.ProgramListAll = [];
          this.notChoiceDataList = [];
          this.errmsg("服务异常，请联系管理员！");
        }
      })
    },
    getOrderProgramshowList(){
      let params={
        pageNum:1,
        pageSize:999,
        orderId:this.taskId
      }
      BroadcastOrderShowList(params).then(res=>{
        // console.log("播单已关联节目")
        // console.log(res)
        if(res.code==200){
          let data = res.rows;
          data.map(item=>{
            this.ProgramData.choiceDataList.push(item.showId)
          })
          // console.log("this.ProgramData.choiceDataList")
          // console.log(this.ProgramData.choiceDataList)
        }
      })
    },
    handleChange(value, direction, movedKeys) {
      // console.log(value, direction, movedKeys);
    },

    OnConfirm(formName) {
      if (this.ProgramData.choiceDataList.length == 0) {
        this.$message({
          showClose: true,
          message: "请确认播放节目",
          type: "warning",
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveInfo();
        } else {
          return false;
        }
      });
    },
    onBack() {
      this.$emit("onBack", {});
    },
    nextStep() {
      this.$emit("nextStep", {});
    },
    preStep() {
      this.$emit("preStep", {});
    },
    search() {
      this.$emit("search", {});
    },
    SaveInfo() {
      if (this.taskId === "") return;
      console.log("this.ProgramList")
      console.log(this.ProgramList)
      console.log(this.ProgramData.choiceDataList)
      // if (this.ProgramList.length > 0) {
      //   let delResult = [];
      //   let addResult = [];
      //   let mapA = {};
      //   let mapB = {};
      //   // 第一次循环得到id对应的map对象
      //   this.ProgramData.choiceDataList.forEach((element) => {
      //     mapA[element] = element;
      //   });
      //   this.ProgramList.forEach((element) => {
      //     mapB[element.ProgramId] = element;
      //   });
      //   //删除的广播节目在ProgramList中存在，在choiceDataList中不存在
      //   //新增的广播节目在ProgramList中不存在，在choiceDataList中存在
      //   this.ProgramList.forEach((item) => {
      //     if (!mapA[item.ProgramId]) {
      //       item.ModifyTime = new Date();
      //       item.Modifier = new Date();
      //       item.Validity = 0;
      //       delResult.push(item);
      //     }
      //   });

      //   this.ProgramData.choiceDataList.forEach((item) => {
      //     let addItem = {};
      //     if (!mapB[item]) {
      //       addItem.TaskId = this.taskId;
      //       addItem.ProgramId = item;
      //       addItem.ModifyTime = new Date();
      //       addItem.Modifier = this.user.UserName;
      //       addItem.Validity = 1;
      //       addItem.CreateTime = new Date();
      //       addItem.Creater = this.user.UserName;
      //       addResult.push(addItem);
      //     }
      //   });

      //   TaskPrograms = delResult.concat(addResult);
      // } else {
      //   TaskPrograms = this.ProgramData.choiceDataList.map((item) => ({
      //     TaskId: this.taskId,
      //     ProgramId: item,
      //     ModifyTime: new Date(),
      //     Modifier: this.user.UserName,
      //     Validity: 1,
      //     CreateTime: new Date(),
      //     Creater: this.user.UserName,
      //   }));
      // }
      
      let params={
        orderId:this.taskId,  //播单id
        showIds:this.ProgramData.choiceDataList
      }
      this.loading = true;
      batchUpdate(params).then(res=>{
        console.log("新增播单关联")
        console.log(res)
        this.loading = false;
        if(res.code==200){
          this.$message({
            type: "success",
            message:"保存成功！"
          });
          this.search();
          this.nextStep();
        }else{
          this.$message({
            type: "success",
            message:"保存失败！"
          });
        }
      })
      // new MyApis.TaskProgramApi()
      //   .UpdateItemList(TaskPrograms)
      //   .then((r) => {
      //     r = r.data.Data;
      //     this.$message({
      //       type: "success",
      //       message: r ? "保存成功！" : "保存失败！",
      //     });
      //     this.loading = false;
      //     this.logInfo.ActionName = "节目管理添加";
      //     this.logInfo.LogMessage = r ? "节目管理添加成功" : "节目管理添加失败";
      //     this.logInfo.ModuleName = "广播系统";
      //     this.logInfo.PageName = "播单管理详情页面";
      //     this.addOperationLog();
      //     this.search();
      //     this.nextStep();
      //   })
      //   .catch((e) => {
      //     this.loading = false;
      //     console.log(e);
      //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //   });
    },
  },
};
</script>

<style lang="scss">
.program-transfer {
  text-align: center;
  .el-transfer-panel {
    border: 1px solid #387ecc;
    background: transparent;
    width: 40rem;
  }
  .el-transfer-panel .el-transfer-panel__header {
    border-bottom: 1px solid #387ecc;
  }
}
</style>
